module.exports = __webpack_public_path__ + "img/facebook-logo.3ae13bc8.svg";